/* HFB-064-AB */
(function () {
    var ARM_CLASS = 'HFB-064-AB--var-1';
    var STORAGE_KEY = 'hfb064-tab';
    var TYPE_HANDLES = {
      supplements: true,
      oils: true,
      'feminine-washes': true,
      'body-washes': true,
      suppositories: true,
      wipes: true,
      deodorants: true
    };
    var SHARED_HANDLES = {
      all: true,
      'all-products': true,
      'bundle-deals': true
    };
  
    function applyArm() {
      document.documentElement.classList.add(ARM_CLASS);
      if (document.body) document.body.classList.add(ARM_CLASS);
      else {
        document.addEventListener('DOMContentLoaded', function () {
          document.body.classList.add(ARM_CLASS);
          requestAnimationFrame(syncMobileOffset);
        });
      }
      requestAnimationFrame(syncMobileOffset);
    }

    function syncMobileOffset() {
      var root = document.documentElement;
      if (!root.classList.contains(ARM_CLASS) && !(document.body && document.body.classList.contains(ARM_CLASS))) {
        return;
      }
      if (window.matchMedia('(min-width: 750px)').matches) {
        root.style.removeProperty('--hfb-064-wrapper-pad');
        return;
      }
      var header = document.getElementById('shopify-section-header');
      if (!header) return;
      var height = Math.round(header.offsetHeight);
      if (height) root.style.setProperty('--hfb-064-wrapper-pad', height + 'px');
    }
  
    function collectionHandle() {
      var match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    }
  
    function inferredTab() {
      var handle = collectionHandle();
      if (TYPE_HANDLES[handle]) return 'type';
      if (SHARED_HANDLES[handle]) {
        try {
          var stored = sessionStorage.getItem(STORAGE_KEY);
          if (stored === 'type' || stored === 'concern') return stored;
        } catch (e) {}
      }
      return 'concern';
    }
  
    function setTab(tab) {
      if (tab !== 'type' && tab !== 'concern') return;
      document.querySelectorAll('[data-hfb-064-root]').forEach(function (root) {
        var radio = root.querySelector('.hfb-064-collection-nav--var-1__radio--' + tab);
        if (radio) radio.checked = true;
      });
      try {
        sessionStorage.setItem(STORAGE_KEY, tab);
      } catch (e) {}
    }
  
    function bindTabs() {
      document.querySelectorAll('[data-hfb-064-root]').forEach(function (root) {
        root.querySelectorAll('.hfb-064-collection-nav--var-1__radio').forEach(function (radio) {
          radio.addEventListener('change', function () {
            if (!radio.checked) return;
            setTab(radio.value);
          });
        });
      });
    }
  
    function bindDrag(list) {
      var desktopMq = window.matchMedia('(min-width: 750px)');
      var pointerDown = false;
      var startX = 0;
      var scrollStart = 0;
      var dragged = false;
      var dragThreshold = 5;
  
      function isScrollable() {
        return list.scrollWidth > list.clientWidth + 1;
      }
  
      function canDrag(e) {
        if (!desktopMq.matches) return false;
        if (e.pointerType === 'touch') return false;
        return isScrollable();
      }
  
      list.addEventListener('pointerdown', function (e) {
        if (!canDrag(e)) return;
        if (e.button !== undefined && e.button !== 0) return;
        pointerDown = true;
        dragged = false;
        startX = e.clientX;
        scrollStart = list.scrollLeft;
        list.classList.add('hfb-064-collection-nav--var-1__list--dragging');
        if (list.setPointerCapture) {
          try {
            list.setPointerCapture(e.pointerId);
          } catch (err) {}
        }
      });
  
      list.addEventListener('pointermove', function (e) {
        if (!pointerDown) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > dragThreshold) dragged = true;
        if (!dragged) return;
        list.scrollLeft = scrollStart - dx;
        e.preventDefault();
      });
  
      function endDrag(e) {
        if (!pointerDown) return;
        pointerDown = false;
        list.classList.remove('hfb-064-collection-nav--var-1__list--dragging');
        if (list.releasePointerCapture && e && e.pointerId !== undefined) {
          try {
            list.releasePointerCapture(e.pointerId);
          } catch (err) {}
        }
      }
  
      list.addEventListener('pointerup', endDrag);
      list.addEventListener('pointercancel', endDrag);
      list.addEventListener('lostpointercapture', function () {
        pointerDown = false;
        list.classList.remove('hfb-064-collection-nav--var-1__list--dragging');
      });
  
      list.addEventListener(
        'click',
        function (e) {
          if (!dragged) return;
          var link = e.target.closest('.hfb-064-collection-nav--var-1__link');
          if (!link) return;
          e.preventDefault();
          e.stopPropagation();
          dragged = false;
        },
        true
      );
    }
  
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('hfb064') === 'var-1') applyArm();
    } catch (e) {}
  
    document.addEventListener('DOMContentLoaded', function () {
      bindTabs();
      setTab(inferredTab());
      document.querySelectorAll('.hfb-064-collection-nav--var-1__list').forEach(bindDrag);
      requestAnimationFrame(syncMobileOffset);
      if (window.MutationObserver) {
        new MutationObserver(function () {
          requestAnimationFrame(syncMobileOffset);
        }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
        if (document.body) {
          new MutationObserver(function () {
            requestAnimationFrame(syncMobileOffset);
          }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
        }
      }
    });

    window.addEventListener('resize', syncMobileOffset);
  })();
  